import { api } from "@/api";
import type {
  NotificationSettings,
  TelegramNotificationLinkStart,
  TelegramNotificationLogPage,
  TelegramNotificationState,
  TelegramNotificationTestOutcome,
} from "@/types/ApiResponses/TelegramNotifications";

// Telegram coupon notifications: every call acts on the signed-in user only.
const BASE = "/telegram-notifications";

export const getTelegramNotificationState = async (props: {
  signal?: AbortSignal;
}): Promise<TelegramNotificationState> =>
  (await api.client.get(BASE, { signal: props.signal })).data;

export const startTelegramNotificationLink =
  async (): Promise<TelegramNotificationLinkStart> =>
    (await api.client.post(`${BASE}/link/start`)).data;

// Reuses the chat already linked for 2FA — one tap, no Telegram round-trip.
export const reuseTelegramNotificationLink = async (): Promise<void> => {
  await api.client.post(`${BASE}/link/reuse`);
};

export const unlinkTelegramNotifications = async (): Promise<void> => {
  await api.client.delete(`${BASE}/link`);
};

export const saveTelegramNotificationSettings = async (
  settings: NotificationSettings
): Promise<void> => {
  const body = {
    settings: Object.entries(settings).map(([event, value]) => ({
      event,
      ...value,
    })),
  };
  await api.client.put(`${BASE}/settings`, body);
};

export const sendTelegramNotificationTest =
  async (): Promise<TelegramNotificationTestOutcome> =>
    (await api.client.post(`${BASE}/test`)).data;

export const getTelegramNotificationLog = async (props: {
  page: number;
  pageSize: number;
  signal?: AbortSignal;
}): Promise<TelegramNotificationLogPage> =>
  (
    await api.client.get(`${BASE}/log`, {
      params: { page: props.page, pageSize: props.pageSize },
      signal: props.signal,
    })
  ).data;
